import { render, staticRenderFns } from "./AssociatedFarms.vue?vue&type=template&id=b66ec8c6&scoped=true"
import script from "./AssociatedFarms.vue?vue&type=script&lang=js"
export * from "./AssociatedFarms.vue?vue&type=script&lang=js"
import style0 from "./AssociatedFarms.vue?vue&type=style&index=0&id=b66ec8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66ec8c6",
  null
  
)

export default component.exports